import React from "react";
import ReactDOM from "react-dom";
import {Provider, connect} from "react-redux";

import {BookButton, BookButtonDiv} from "../../../spaceplanner/styles/Common/button";
import { ModalController } from "../../../../src/common/components/Modal";
import LabelIcon from "calcite-ui-icons-react/LabelIcon";

import Attributes from "./Attributes";
import Context from "../../../context/Context";
import InfoPanelHeader from "./InfoPanelHeader";
import Rdx from "../../../redux/Rdx";
import Related from "./Related";
import RealTimeLocation from "./RealTimeLocation";
import ShareDropdown from "./ShareDropdown";
import Topic from "../../../context/Topic";
import * as Actions from "./Actions";
import * as actionUtil from "./actionUtil";
import * as appLaunchUtil from "../../../aiim/util/appLaunchUtil";
import * as component from "../../util/component";
import * as itemUtil from "../../../aiim/util/itemUtil";
import * as shareUtil from "./shareUtil";
import { login, getAccessToken, getBookingSchedule, bookWorkspace, getLoggedInUser } from "../../../../src/components/main/More/Actions/BookWorkspace/OfficeHotelingInterface";
import Office365 from "../../../../src/components/main/More/Actions/BookWorkspace/Office365";
import FieldNames from "../../../../src/aiim/datasets/FieldNames";
import * as aiimUtil from "../../../../src/aiim/util/aiimUtil";
import * as AreaDetails from "./AreaDetails";
import BookingDetails from "../More/Actions/BookWorkspace/BookingDetails";
import { Field } from "formik";
import BookingConfirmed from "../More/Actions/BookWorkspace/BookingConfirmed";

const CSS = {
  main: "i-content",
  infopanelContent: "i-infopanel-content",
  featureContent: "i-infopanel-content-feature",
  actionBar: "i-actionbar",
  tabs: "tab-nav",
  tab: "tab-title",
  activeTab: "is-active",
  tabContent: "i-infopanel-feature-tabcontent",
  bookButton: "i-bookbutton",
  bookButtonDiv: "i-bookbuttondiv",
  actionBarContainer: "i-actionbar-container",
  infopanelBookButton: "i-infopanel-book-button"
};


class ItemDetails extends React.Component {

  constructor(props) {
    super(props);
    const item = this.props.item;
    this.bookingSystem = Office365.getInstance();
    this.state = component.newState({
      activeTab: "attributes",
      appLaunchUrls: [],
      mode: "details",
      _311Url: null,
      shareUrl: shareUtil.generateShareUrl(item),
      spaceType : null,
      areaName : null,
      scheduleEmail : null,
      levelName: null
    });
    this.modeClicked = this.modeClicked.bind(this);
    this.tabClicked = this.tabClicked.bind(this);
  }

  
  bookClicked = (item, scheduleEmail) =>{
    const attributes = item.searchResult.feature.attributes;
    const areaId = aiimUtil.getAttributeValue(attributes, FieldNames.AREA_ID);
    const spaceType = aiimUtil.getAttributeValue(attributes, FieldNames.UNITS_USE_TYPE);
    const unitName = aiimUtil.getAttributeValue(attributes, FieldNames.NAME);
    const levelName = aiimUtil.getAttributeValue(attributes, FieldNames.LEVEL_NAME);
    const facilityName = aiimUtil.getAttributeValue(attributes, FieldNames.FACILITY_NAME);
    const bookingSystem = this.bookingSystem;
    let url = null;
    if(item && item.searchResult && item.searchResult.feature && item.searchResult.feature.layer && item.searchResult.feature.layer.url)
      url = item.searchResult.feature.layer.url;

    let user = getLoggedInUser(bookingSystem)
    if (user) {
      return getAccessToken(bookingSystem)
      .then((token)=>{
        if(token) return AreaDetails.getAreaName(areaId, url);
      })
      .then((areaName)=> {
        this.setState({
          spaceType : spaceType,
          areaName : areaName,
          scheduleEmail : scheduleEmail,
          unitName : unitName,
          levelName : levelName,
          facilityName : facilityName
        }, ()=>{
          this.renderBookingDetails();
        })
      })
      .catch(error =>{
        console.log("Error in booking workspace.", error);
      })
    } else {
      return login(bookingSystem)
      .then((status)=>{
        if(status === "Success") return AreaDetails.getAreaName(areaId, url);
      })
      .then((areaName)=> {
        this.setState({
          spaceType : spaceType,
          areaName : areaName,
          scheduleEmail : scheduleEmail,
          unitName : unitName,
          levelName : levelName,
          facilityName : facilityName
        }, ()=>{
          this.renderBookingDetails();
        })
      })
      .catch(error =>{
        console.log("Error in booking workspace.", error);
      })
    }
  }

  componentDidMount() {
    //this.generate311Url();
    this.generateAppLaunchUrls()
    component.own(this,[
      Topic.subscribe(Topic.AppLaunchURLsChanged,params => {
        this.generateAppLaunchUrls();
      }),
      Topic.subscribe(Topic.ReferenceLayerUpdated,params => {
        component.refresh(this);
      }),
      Topic.subscribe(Topic.Three11UrlChanged,params => {
        this.generate311Url();
      }),
      Topic.subscribe(Topic.LayerVisibilityChanged, params => {
        console.log("refresh")
        this.setState({
          shareUrl: shareUtil.generateShareUrl(this.props.item)
        })
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  confirmBooking =(checkInDate, checkOutDate)=> {
    // return login(this.bookingSystem)
    // .then((status)=> {
    //   if(status === "Success") return getAccessToken(this.bookingSystem);
    // })
    return getAccessToken(this.bookingSystem).then((token) =>{
      const scheduleEmail = this.state.scheduleEmail;
      const unitName = this.state.unitName;
      return bookWorkspace(this.bookingSystem, token, scheduleEmail, unitName, checkInDate, checkOutDate, this.props.item);
    })
    .then((response) => {
      if(response){
        this.renderBookingConfirmed();    
      }
    })
    .catch((error) =>{
      console.log("Error", error);
    })
  }

  checkAvailability =(checkInDate, checkOutDate)=> {
    // return login(this.bookingSystem)
    // .then((status)=> {
    //   if(status === "Success") return getAccessToken(this.bookingSystem);
    // })
    return getAccessToken(this.bookingSystem).then((token) =>{
      const scheduleEmail = this.state.scheduleEmail;
      const params = {
        schedules : [scheduleEmail],
        startTime : {
          dateTime : checkInDate,
          timeZone: "UTC"
        },
        endTime : {
          dateTime : checkOutDate,
          timeZone: "UTC"
        }
      }
      return getBookingSchedule(this.bookingSystem, token, params);
    })
    .then((availability)=> {
      if(availability && availability.value){
        const scheduleItemsLength = availability.value[0].scheduleItems.length;
        if(scheduleItemsLength === 0){
          this.confirmBooking(checkInDate, checkOutDate);
        }else{
          const i18n = Context.getInstance().i18n;
          let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
          title = title.replace("{unitName}", this.state.unitName);
          let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
          errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
          ModalController.confirm({
            isError: true,
            title: title,
            message: errorMessage,
            submessage: null,
            hideCancel:true
          });
        }
      }
    })
    .catch(()=> {
      const i18n = Context.getInstance().i18n;
      let title = i18n.more.bookWorkspace.workspaceUnavailableTitle;
      let errorMessage = i18n.more.bookWorkspace.workspaceUnavailable;
      errorMessage = errorMessage.replace("{unitName}", this.state.unitName);
      ModalController.confirm({
        isError: true,
        title: title,
        message: errorMessage,
        submessage: null,
        hideCancel:true
      });
    })
  }

  generateAppLaunchUrls() {
    appLaunchUtil.generateUrlsCategoriesAndLayers(this.props.item).then(urls => {
      this.setState({
        appLaunchUrls: urls
      });
    }).catch(ex => {
       console.error("Error generating app launch urls",ex);
    });
    // appLaunchUtil.generateUrls(this.props.item).then(urls => {
    //   //console.log("urls222",urls);
    //   this.setState(state => {
    //     return {
    //       appLaunchUrls: urls
    //     };
    //   });
    // }).catch(ex => {
    //    console.error("Error generating app launch urls",ex);
    // });
  }

  generate311Url() {
    actionUtil.generate311Url(this.props.item).then(url => {
      this.setState(state => {
        return {
          _311Url: url
        };
      });
    }).catch(ex => {
       console.error("Error generating 311 URL",ex);
    });
  }

  getCaption() {
    const v = this.props.item.getTitle();
    if (typeof v === "string") return v;
    return "";
  }

  getFeature() {
    return (this.props.item.getFeature());
  }

  getSource() {
    return (this.props.item.getSource());
  }

  modeClicked(mode) {
    // const activeModeKey = this.props.infoPanelKey + "-ItemDetails-ActiveMode";
    // if (mode) {
    //   Rdx.setValue(this,activeModeKey,mode);
    // }
    this.setState(state => {
      return {
        mode: mode
      };
    });
    if (this.props.realTimeToggled) this.props.realTimeToggled(mode);
  }

  render() {
      return (
        <div className={CSS.main}>
          {this.renderHeader()}
          {this.renderContent()}
        </div>
      );
  }

  renderActions() {
    const isKiosk = Context.getInstance().isKiosk;
    const item = this.props.item;
    const appLaunchUrls = this.state.appLaunchUrls;
    const listItems = [];

    const source = this.getSource();
    const feature = this.getFeature();
    const hasGeometry = itemUtil.hasGeometry(source,feature);

    const attributes = feature.attributes;
    const scheduleEmail = aiimUtil.getAttributeValue(attributes,FieldNames.SCHEDULE_EMAIL);
    const assignmentType = aiimUtil.getAttributeValue(attributes, FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
    let bookUnit;

    if (item && item.isValid()) {
      if (Context.getInstance().config.networkServiceUrl) {
        listItems.push(
          <li key="directions"><Actions.Directions item={item} disabled={!hasGeometry}/></li>
        );
      }
      if (!isKiosk) {
        listItems.push(
          <li key="setHome"><Actions.SetHome item={item} disabled={!hasGeometry}/></li>
        );
        listItems.push(
          <li key="saveFavorite"><Actions.SaveFavorite item={item} disabled={!hasGeometry}/></li>
        );
        if (this.state.shareUrl) {
          listItems.push(
            <li key="share"><ShareDropdown shareUrl={this.state.shareUrl} caption={this.getCaption()}/></li>
          );
        }

        // if (this.state._311Url) {
        //   listItems.push(
        //     <li key="launch311"><Actions.Launch311 _311Url={this.state._311Url}/></li>
        //   );
        // }

        if (appLaunchUrls && appLaunchUrls.length > 0) {
          listItems.push(
            <li key="appLaunch"><Actions.AppLaunch urls={appLaunchUrls}/></li>
          );
        }

        const configuration = Context.instance.configuration;
        const configurables = configuration.extractConfigurables();
        if (configurables.officeHoteling && configurables.officeHoteling.enabled){
          if(scheduleEmail && assignmentType === "hotel"){
            const i18n = Context.getInstance().i18n;
            bookUnit = (
              <BookButtonDiv>
                <BookButton tabIndex="0" role="button" aria-label={i18n.more.bookWorkspace.bookInfoAriaLabel} 
                    iconPosition={"before"} clear icon={<LabelIcon/>}
                    onClick={()=>this.bookClicked(item, scheduleEmail)}>
                  {i18n.more.bookWorkspace.bookButton}
                </BookButton>
              </BookButtonDiv>
            )
          }
        }
      }
    }

    if (listItems.length === 0) return null;
    return (
      <div className={CSS.actionBarContainer}>
      <ul className={CSS.actionBar}>
        {listItems}
      </ul>
      <div className={CSS.infopanelBookButton}>
      {bookUnit}
      </div>
      </div>
    );
  }

  
  renderBookingConfirmed(){
    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };
    
    ReactDOM.render((
      <BookingConfirmed 
            unitName = {this.state.unitName}
            levelName = {this.state.levelName}
            facilityName = {this.state.facilityName}
            closePopup = {onClose}
      />
    ), node);
  }

  renderBookingDetails(){
    const node = document.createElement("div");
    document.body.appendChild(node);
    const spaceType = this.state.spaceType;
    const areaName = this.state.areaName;

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <Provider store={Rdx.store}>
        <BookingDetails 
          spaceType = {spaceType} areaName = {areaName} 
          scheduleEmail = {this.state.scheduleEmail}
          unitName = {this.state.unitName}
          levelName = {this.state.levelName}
          facilityName = {this.state.facilityName}
          checkAvailability = {this.checkAvailability}
          isBookWorkspacePanel = {this.props.isBookWorkspacePanel}
          closePopup = {onClose}
        />
      </Provider>
    ), node);
  }

  renderContent() {
    const i18n = Context.getInstance().i18n;
    //const isKiosk = Context.getInstance().uiMode.isKiosk;
    const isAnonymous = Context.getInstance().user.isAnonymous();
    const feature = this.getFeature();
    //if (!feature || !feature.geometry) {
    if (!feature) {
      return (
        <div className="i-padded">
          <p>{i18n.infoPanel.messages.noGeometry}</p>
        </div>
      );
    }
    const source = this.getSource();
    const item = this.props.item;
    const itemIsValid = (source && item && item.isValid());
    const hasGeometry = itemUtil.hasGeometry(source,feature);

    let canObserve = false, realTime = null;
    const detailsStyle = {};
    //const activeMode = this.props.rdxActiveMode || "details";
    const activeMode = this.state.mode || "details";
    //if (!isKiosk && !isAnonymous && itemIsValid && source.isAiimPeople()) {
    if (!isAnonymous && itemIsValid && source.isAiimPeople()) {
      const trackingViews =  Context.getInstance().user.trackingViews;
      if (trackingViews) {
        canObserve = trackingViews.canObserve(source,feature);
        if (canObserve) {
          if (activeMode === "realtime") detailsStyle.display = "none";
          realTime = (
            <RealTimeLocation infoPanelKey={this.props.infoPanelKey} item={item}
              modeClicked={this.modeClicked} />
          );
        }
      }
    }

    const activeTab = this.props.rdxActiveTab || "attributes";
    const tabs = (
      <>
      {/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */}
      <nav className={CSS.tabs} role="tablist">
        {this.renderTab(activeTab,"attributes",i18n.infoPanel.tabs.attributes)}
        {this.renderTab(activeTab,"related",i18n.infoPanel.tabs.related,!hasGeometry)}
      </nav>
      </>
    );

    let bookUnit;
    const attributes = item.searchResult.feature.attributes;
    const scheduleEmail = aiimUtil.getAttributeValue(attributes,FieldNames.SCHEDULE_EMAIL);
    const assignmentType = aiimUtil.getAttributeValue(attributes, FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);

    // if(scheduleEmail && assignmentType === "hotel"){
    //   bookUnit = (
    //     <BookButtonDiv>
    //       <BookButton iconPosition={"after"} clear icon={<LabelIcon/>}
    //           onClick={()=>this.bookClicked(item, scheduleEmail)}>
    //         Book
    //       </BookButton>
    //     </BookButtonDiv>
    //   )
    // }
    
    let tabContent = null;
    if (itemIsValid) {
      tabContent = (
        <div key="i-feature-tabcontent" className={CSS.tabContent}>
          <Attributes item={item} active={activeTab === "attributes"}/>
          <Related item={item} active={activeTab === "related"}/>
        </div>
      );
    }

    return (
      <div key="i-infopanel-content" className={CSS.infopanelContent}>
        {realTime}
        <div key="i-feature-content" className={CSS.featureContent} style={detailsStyle}>
          {this.renderActions()}
          {/* {bookUnit} */}
          {tabs}
          {this.props.backNextButtons}
          {tabContent}
        </div>
      </div>
    );
  }

  renderHeader() {
    const caption = this.getCaption();
    return <InfoPanelHeader caption={caption} infoPanelKey={this.props.infoPanelKey}/>
  }

  renderTab(activeTab,type,label,disabled) {
    let className = CSS.tab;
    const selected = (activeTab === type);
    if (selected) className += " " + CSS.activeTab;
    if (disabled) className += " i--disabled";
    const tab = (
      <button className={className} role="tab" aria-selected={selected}
      onClick={this.tabClicked} data-tabtype={type}><span data-tabtype={type}>{label}</span></button>
    )
    return tab;
  }

  tabClicked(event) {
    try {
      const activeTabKey = this.props.infoPanelKey + "-ItemDetails-ActiveTab";
      const type = event.target.getAttribute("data-tabtype");
      if (type) {
        Rdx.setValue(this,activeTabKey,type);
      }
    } catch(ex) {
      console.warn("Error handling tab click for event:",event);
      console.error(ex);
    }
  }

}

const mapStateToProps = (state,ownProps) => {
  //const activeModeKey = ownProps.infoPanelKey + "-ItemDetails-ActiveMode";
  const activeTabKey = ownProps.infoPanelKey + "-ItemDetails-ActiveTab";
  return {
    //rdxActiveMode: Rdx.getValue(state,activeModeKey),
    rdxActiveTab: Rdx.getValue(state,activeTabKey)
  }
}

export default connect(mapStateToProps)(ItemDetails);
